import React, { useState } from 'react';
import '../../../utils/date';
import FilterIcon from '../../../icons/FilterIcon';
import PlusIcon from '../../../icons/PlusIcon';
import DateMonthPicker from '../../../components/common/DateMonthPicker';
import StatusDropdown from './StatusDropdown';
import { Modal, FormControl, InputLabel, Select } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import { AddFilePanelBackoffice } from '../Autoral/components/Panels';
import { AddFilePanelCompanies } from '../Conexo/components/Panels';

export const defaultFilters = {
  status: null,
  date: null,
  source: null,
};

const OptionsFont = [
  { value: 1, label: "Believe" },
  { value: 2, label: "TheOrchard" },
  { value: 3, label: "OneRPM" },
  { value: 4, label: "Ingrooves" },
  // { value: 5, label: "Altafonte" },
  { value: 6, label: "FUGA" },
  { value: 7, label: "Ingrooves USA" },
  { value: 8, label: "Universal" },
  // { value: 9, label: "SomLivre" },
  // { value: 10, label: "Symphonic" },
  // { value: 11, label: "CmdShift" },
  { value: 12, label: "Universal2" },
  { value: 13, label: "Believe2" },
  { value: 14, label: "Virgin" },
];

const SortOptionsFonts = OptionsFont.sort((a, b) =>
  a.label.localeCompare(b.label)
);

const OptionsBackoffice = [
  // { value: 1, label: "Youtube" },
  { value: 2, label: "Backoffice" },
  // { value: 3, label: "Deezer BMAT" },
];

const SortOptionsBackoffice = OptionsBackoffice.sort((a, b) =>
  a.label.localeCompare(b.label)
);

const ActionBar = (props) => {
  const [showFilters, showHideFilters] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [referenceDate, setReferenceDate] = useState(null);

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    props.onFilterChange(newFilters);
  };

  const onStatusChangeHandler = (e) => {
    const status = e.target.value;
    updateFilters({ ...filters, status: status });
  };
  const onDateChange = (rawDate, date) => {
    setReferenceDate(rawDate);
    updateFilters({ ...filters, date: date });
  };
  const onSourceChangeHandler = (source) => {
    updateFilters({ ...filters, source: source });
  };
  const onFileSaveHandler = (success) => {
    if (success) setShowForm(false); // do not hide the form if there was an error uploading the file
    props.onSave(success);
  };

  return (
    <>
      <div className="page-actionbar-container">
        <div
          className="page-actionbar-item action-btn"
          onClick={() => showHideFilters(!showFilters)}
        >
          <FilterIcon />
        </div>
        {props.isBackoffice && props.hasRole(['PAYMENT_FILE_WORKS_WRITE']) ? (
          <div
            className="page-actionbar-item action-btn"
            onClick={() => {
              setShowForm(true);
            }}
          >
            <PlusIcon />
          </div>
        ) : null}

        {props.isCompanies && props.hasRole(['PAYMENT_FILE_TRACKS_WRITE']) ? (
          <div
            className="page-actionbar-item action-btn"
            onClick={() => {
              setShowForm(true);
            }}
          >
            <PlusIcon />
          </div>
        ) : null}
      </div>
      {showFilters ? (
        <div className="page-filter-bar">
          <DateMonthPicker
            className="filter-date"
            label="Data"
            format="MM/yyyy"
            view={['month', 'year']}
            value={referenceDate}
            onChange={onDateChange}
          />
          <StatusDropdown onStatusChange={onStatusChangeHandler} />
          <FormControl margin="normal" style={{ width: '100%' }}>
            <InputLabel style={{ padding: '0 10px' }}> Fonte </InputLabel>
            <Select
              native
              label="Fonte"
              onChange={(e) => {
                onSourceChangeHandler(e.target.value);
              }}
              variant="outlined"
            >
              {props.isBackoffice ? (
                <>
                  <option aria-label="None" value="" />
                  {SortOptionsBackoffice.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </>
              ) : (
                <>
                  <option aria-label="None" value="" />
                  {SortOptionsFonts.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </>
              )}
            </Select>
          </FormControl>
        </div>
      ) : null}

      {props.isBackoffice ? (
        /* Modal dialog for adding new report file */
        <Modal
          open={showForm}
          onClose={() => {
            setShowForm(false);
          }}
          slotsslotsbackdropprops={Backdrop}
          slotsbackdropprops={{ timeout: 500 }}
        >
          <div className="modal-container add-file">
            <AddFilePanelBackoffice onSave={onFileSaveHandler} />
          </div>
        </Modal>
      ) : null}
      {props.isCompanies ? (
        /* Modal dialog for adding new report file */
        <Modal
          open={showForm}
          onClose={() => {
            setShowForm(false);
          }}
          slotsbackdropprops={Backdrop}
        >
          <div className="modal-container add-file">
            <AddFilePanelCompanies onSave={onFileSaveHandler} />
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default ActionBar;
